import React, { Children } from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function WhyUseSection() {
  const features = [{
    image: 'https://cdn.magicpatterns.com/uploads/5kWDjtSuzvBxKvTX8rwNYX/Captura_de_pantalla_2026-04-09_101822.png',
    alt: '+10000 Diseños Premium'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/wq5wJ33vh3KU1iSq92JLdo/Captura_de_pantalla_2026-04-09_101836.png',
    alt: 'Kit Completo de Decoración'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/tJZah4YsKFxvcuLbUVLZAg/Captura_de_pantalla_2026-04-09_101850.png',
    alt: 'Fácil de usar'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/k8hQaE1KRSHhb3msJod8vG/Captura_de_pantalla_2026-04-09_101901.png',
    alt: 'Oportunidad de negocio'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/5gP2FWDQxeM6MrMtV5E6AJ/Captura_de_pantalla_2026-04-09_101912.png',
    alt: 'Descarga inmediata'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/8qBzpWWi2sg4sLqiqAYHPJ/Captura_de_pantalla_2026-04-09_101925.png',
    alt: 'Personalizable'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 300
      }
    }
  };
  return <Section className="bg-white" data-id="element-242">
      <div className="text-center mb-16" data-id="element-243">
        <div className="inline-block bg-partyPink-hot text-white px-8 py-3 rounded-full shadow-md transform -rotate-1 mb-6" data-id="element-244">
          <h2 className="text-2xl md:text-3xl font-bold uppercase tracking-wider flex items-center" data-id="element-245">
            <CheckCircle2 className="mr-2" data-id="element-246" /> ¿Por qué usar este kit de fiesta?
          </h2>
        </div>
      </div>

      <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
      once: true,
      margin: '-50px'
    }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-247">
        {features.map((feature, index) => <motion.div key={index} variants={itemVariants} className="rounded-3xl overflow-hidden shadow-soft hover:shadow-lg transition-all duration-300 transform hover:-translate-y-2 border-2 border-white aspect-square" data-id="element-248">
            {feature.image ? <img src={feature.image} alt={feature.alt} className="w-full h-full object-cover" data-id="element-249" /> : <div className="w-full h-full bg-partyPink-light flex items-center justify-center" data-id="element-250">
                <p className="text-gray-400 font-bold text-lg" data-id="element-251">Imagen #6</p>
              </div>}
          </motion.div>)}
      </motion.div>
    </Section>;
}